export default {"src":"/_next/static/media/ic_refresh.76702814.svg","height":34,"width":32,"blurWidth":0,"blurHeight":0};